export default __webpack_public_path__ + "static/media/icon-ionic-logo-whatsapp.3dc88e2d.svg";